import * as React from "react";

function SvgIkonaSeznamSubjektu(props) {
  return (
    <svg
      data-name="Vrstva 1"
      viewBox="0 0 400 400"
      width="1em"
      height="1em"
      {...props}
    >
      <path d="M114.19 139.62V99.83H350v39.79zM50 139.62V99.83h34.81v39.79zM114.2 219.9v-39.79h235.81v39.79zM50 219.9v-39.79h34.81v39.79zM114.19 300.17v-39.79H350v39.79zM50 300.17v-39.79h34.81v39.79z" />
    </svg>
  );
}

export default SvgIkonaSeznamSubjektu;

